import script from "./ReleaseLogViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReleaseLogViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ReleaseLogViewer.vue?vue&type=style&index=0&id=764da0d4&scoped=true&lang=css"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764da0d4"]])

export default __exports__